import { FormInput, FormInputProps } from 'modules';
import React from 'react';

export enum PropertyType {
  NO_PROPERTY = 'Nie ste vlastníkom žiadnej nehnuteľnosti na území Slovenskej republiky.',
  HOUSE = 'Dom',
  APARTMENT = 'Byt',
  COTTAGE = 'Chata',
  GARDEN = 'Zahrada',
  FIELD = 'Pole',
  LAND = 'Pozemok',
  FOREST = 'Les',
  OTHER = 'Iné',
}

const PropertySelect = (props: FormInputProps) => {
  const options = [
    {
      label: PropertyType.NO_PROPERTY,
      value: PropertyType.NO_PROPERTY,
    },
    {
      label: PropertyType.HOUSE,
      value: PropertyType.HOUSE,
    },
    {
      label: PropertyType.APARTMENT,
      value: PropertyType.APARTMENT,
    },
    {
      label: PropertyType.COTTAGE,
      value: PropertyType.COTTAGE,
    },
    {
      label: PropertyType.GARDEN,
      value: PropertyType.GARDEN,
    },
    {
      label: PropertyType.FIELD,
      value: PropertyType.FIELD,
    },
    {
      label: PropertyType.LAND,
      value: PropertyType.LAND,
    },
    {
      label: PropertyType.FOREST,
      value: PropertyType.FOREST,
    },
    {
      label: PropertyType.OTHER,
      value: PropertyType.OTHER,
    },
  ];

  return <FormInput {...props} type={'select'} options={options} />;
};

export default PropertySelect;
